import React from 'react';
import {
	UNLICENSED,
	STANDARD_EDITION,
	FREE_EDITION,
} from '@jira/platform__application-editions/src/edition.tsx';
import { ServiceHubNotFound } from '@jira/servicedesk__spa-commons/src/GenericError.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

type Props = {
	children: React.ReactNode;
	showErrorPageOnNotFound?: boolean;
};

// We need to use the legacy app edition licence state check to determine Premium/Enterprise
// customer service access. The previous tenantContexts entitlementInfo GraphQL query was restricted
// to instance admins,which incorrectly excluded users who have project-level admin access only.
export const JCSOfferingEdition = ({
	children,
	showErrorPageOnNotFound = false,
}: Props): JSX.Element | null => {
	const { hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService } = useAppEditions();

	const isEligible =
		hasCustomerServiceAccess &&
		customerService !== UNLICENSED &&
		customerService !== FREE_EDITION &&
		customerService !== STANDARD_EDITION;

	if (!isEligible) {
		return showErrorPageOnNotFound ? <ServiceHubNotFound /> : null;
	}

	return <>{children}</>;
};
